import IconWrapper from './icon-wrapper';

const normalIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.0305 13L1.67543 13.1218C0.774856 13.4309 0.774856 14.7045 1.67543 15.0136L8.9267 17.5018C9.34742 17.6462 9.80426 17.6462 10.225 17.5018L17.4762 15.0136C18.3768 14.7045 18.3768 13.4309 17.4762 13.1218L17.3024 13.0622L14.0536 14.0618L14.0707 14.0677L9.57584 15.6101L8.96328 15.3999L8.91896 15.411L5.08389 14.0687L5.08101 14.0677L5.08104 14.0677L2.0305 13Z"
      fill="#595959"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.0305 9L1.67543 9.12184C0.774856 9.43087 0.774856 10.7045 1.67543 11.0136L8.9267 13.5018C9.34742 13.6462 9.80426 13.6462 10.225 13.5018L17.4762 11.0136C18.3768 10.7045 18.3768 9.43087 17.4762 9.12184L17.3024 9.0622L14.0536 10.0618L14.0707 10.0677L9.57584 11.6101L8.96328 11.3999L8.91896 11.411L5.08389 10.0687L5.08101 10.0677L5.08104 10.0677L2.0305 9Z"
      fill="#595959"
    />
    <path
      d="M1.75653 6.6026C0.855957 6.29357 0.855957 5.0199 1.75653 4.71088L9.0078 2.22263C9.42852 2.07827 9.88536 2.07827 10.3061 2.22263L17.5574 4.71088C18.4579 5.0199 18.4579 6.29357 17.5574 6.6026L10.3061 9.09084C9.88536 9.23521 9.42852 9.23521 9.0078 9.09084L1.75653 6.6026Z"
      fill="url(#paint0_linear_1517_7867)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1517_7867"
        x1="1.00006"
        y1="5"
        x2="9.65694"
        y2="14.6525"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B9B9B9" />
        <stop offset="1" stopColor="#7B7B7B" stopOpacity="0.01" />
      </linearGradient>
    </defs>
  </svg>
);
const activedIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.0305 13L1.67543 13.1218C0.774856 13.4309 0.774856 14.7045 1.67543 15.0136L8.9267 17.5018C9.34742 17.6462 9.80426 17.6462 10.225 17.5018L17.4762 15.0136C18.3768 14.7045 18.3768 13.4309 17.4762 13.1218L17.3024 13.0622L14.0536 14.0618L14.0707 14.0677L9.57584 15.6101L8.96328 15.3999L8.91896 15.411L5.08389 14.0687L5.08101 14.0677L5.08104 14.0677L2.0305 13Z"
      fill="#2D64FF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.0305 9L1.67543 9.12184C0.774856 9.43087 0.774856 10.7045 1.67543 11.0136L8.9267 13.5018C9.34742 13.6462 9.80426 13.6462 10.225 13.5018L17.4762 11.0136C18.3768 10.7045 18.3768 9.43087 17.4762 9.12184L17.3024 9.0622L14.0536 10.0618L14.0707 10.0677L9.57584 11.6101L8.96328 11.3999L8.91896 11.411L5.08389 10.0687L5.08101 10.0677L5.08104 10.0677L2.0305 9Z"
      fill="#2D64FF"
    />
    <path
      d="M1.75653 6.6026C0.855957 6.29357 0.855957 5.0199 1.75653 4.71088L9.0078 2.22263C9.42852 2.07827 9.88536 2.07827 10.3061 2.22263L17.5574 4.71088C18.4579 5.0199 18.4579 6.29357 17.5574 6.6026L10.3061 9.09084C9.88536 9.23521 9.42852 9.23521 9.0078 9.09084L1.75653 6.6026Z"
      fill="url(#paint0_linear_1517_7857)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1517_7857"
        x1="-1.10208"
        y1="5.99375"
        x2="8.56776"
        y2="18.516"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B3EE" />
        <stop offset="1" stopColor="#2BCAFF" stopOpacity="0.01" />
      </linearGradient>
    </defs>
  </svg>
);

export default function IconPlantform() {
  return <IconWrapper normalIcon={normalIcon} activedIcon={activedIcon} />;
}
